import { useMemo } from 'react';
import { IRequestOptions, useProvider } from '~/Hooks';
import { ExtendedEventGroup } from '~/Screens/Events/EventCreate/ExtendedEventGroup.model';
import { routeReplacer } from '~/Helpers/String.helper';
import { EVENT_SERVICE_URLS } from '~/Constants/Urls.constants';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { EventType } from '~/Models/DTO/Event.model';
import { omit } from 'lodash-es';

export const useEventGroupRequestParams = () => {
  const { currentProvider } = useProvider();

  return useMemo(
    () => ({
      eventGroups,
      id = '',
      shouldSyncEventGroup = false,
    }: {
      eventGroups: Partial<ExtendedEventGroup>;
      id?: string;
      shouldSyncEventGroup?: boolean;
    }): IRequestOptions => {
      const method = id ? 'PUT' : 'POST';
      const syncProps =
        method === 'POST' && shouldSyncEventGroup
          ? {
              syncUrbanSports: true,
              syncOnefit: true,
            }
          : {};
      if (eventGroups.type === EventType.FREE_TRAINING) {
        return {
          url: id
            ? routeReplacer(EVENT_SERVICE_URLS.SINGLE_FREE_TRAININGS, { id })
            : EVENT_SERVICE_URLS.FREE_TRAININGS,
          method,
          data: {
            ...omit(eventGroups, ['seats', 'waitingListEnabled', 'type']),
            // trainerIds is mandatory field, but for free training it has to be empty Array
            trainerIds: [],
            categoryType: EventType.FREE_TRAINING,
            providerId: currentProvider?.uuid || '',
            ...syncProps,
            syncOnefit: undefined,
          },
          actionName: REQUEST_ACTIONS.POST_EVENTGROUP,
        };
      }

      return {
        url: id
          ? routeReplacer(EVENT_SERVICE_URLS.SINGLE_EVENTGROUP, { id })
          : EVENT_SERVICE_URLS.EVENT_GROUPS,
        method,
        data: { ...eventGroups, providerId: currentProvider?.uuid || '', ...syncProps },
        actionName: REQUEST_ACTIONS.POST_EVENTGROUP,
      };
    },
    [currentProvider],
  );
};
